import numeral from 'numeral';
import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import DropDown from '../../Component/DropDown/DropDown';
import { PaginationComponent } from '../../Component/Pagination/Pagination';
import PropertyHorizontalCard from '../../Component/PropertyHorizontalCard/PropertyHorizontalCard';
import Tabs from '../../Component/Tabs';
import classes from './CompanyDetailPage.module.css';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import AgentCard from '../../Component/AgentCard/AgentCard';
import BannerImageAd from '../../Component/BannerImageAd';
import CompanyIntroSection from '../../Component/CompanyIntroSection/CompanyIntroSection';
import EventHorizontalCard from '../../Component/EventHorizontalCard/EventHorizontalCard';
import Footer from '../../Component/Footer';
import Header from '../../Component/Header';
import { Loader } from '../../Component/Loader';
import NoData from '../../Component/NoData/NoData';
import ProjectHorizontalCard from '../../Component/ProjectHorizontalCard/ProjectHorizontalCard';
import { imageUrl, recordsLimit15 } from '../../config/apiUrl';
import { propertyPurposeOptions } from '../../constant/commonData';
import EmailAgentModal from '../../modals/EmailAgentModal';
import {
  useGetPublicCompanyDetailQuery,
  useGetPublicCompanyEntitiesMutation
} from '../../store/apiSlice/apiSlice';

const CompanyDetailPage = () => {
  const { t } = useTranslation('agentOrCompanyDetail');

  const _tabsData = [
    {
      id: 1,
      text: t('company.tabs.properties'),
      value: 'property'
    },
    {
      id: 2,
      text: t('company.tabs.projects'),
      value: 'project'
    },
    {
      id: 3,
      text: t('company.tabs.events'),
      value: 'event'
    },
    {
      id: 4,
      text: t('company.tabs.agents'),
      value: 'agent'
    }
  ];
  const { selectedLanguage } = useSelector((state) => state.languageReducer);
  const slug = useParams()?.slug;
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState(_tabsData[0]);
  const [featuredFilterValue, setFeaturedFilterValue] = useState('');
  const [propertyPurpose, setPropertyPurpose] = useState('');
  const [selectedItem, setSelectedItem] = useState(null);
  const [page, setPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState('');

  const [searchParams] = useSearchParams();
  const adminToken = searchParams.get('token') || '';

  const { allBanners } = useSelector((state) => state.commonReducer);
  const verticalBanners = allBanners?.filter(
    (item) => item?.page === 'company-detail' && item?.bannerType == 'vertical'
  );
  const horizontalBanners = allBanners?.filter(
    (item) => item?.page === 'company-detail' && item?.bannerType == 'horizontal'
  );

  const { data, isLoading } = useGetPublicCompanyDetailQuery({
    slug: `${slug}?token=${adminToken || ''}`
  });
  const [getData, { data: propertyOrAgent, isLoading: isGetting, isFetching }] =
    useGetPublicCompanyEntitiesMutation();
  const companyData = data?.data;

  async function getDataByType(pg = page, filters = {}, type = selectedTab?.value) {
    getData({
      slug,
      type: type,
      page: pg,
      data: { ...filters, lan: selectedLanguage },
      limit: recordsLimit15
    });
  }

  // scroll to top
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
      left: 0
    });
    getDataByType();
  }, []);

  const handleRefetch = () => {
    setPage(1);
    getDataByType(1, {
      ...(propertyPurpose?.value
        ? {
            propertyPurpose: propertyPurpose?.value?.propertyPurpose?.[selectedLanguage]
          }
        : {}),
      ...(featuredFilterValue?.value ? featuredFilterValue?.value : {})
    });
  };

  return (
    <>
      <style>
        {`
        .smDropdown__indicator{
            padding: 0px 8px;
        }
        .smDropdown__control{
            border-radius: 0;
        }
        `}
      </style>

      <div className={classes?.mainPage}>
        <Header containerClass={''} />

        {isLoading ? (
          <Loader />
        ) : (
          <Container className={`${classes?.mainContainer} `}>
            {/* Agent Intro Section: 2Col => Agent Intro, 8Col => About Me, 2Col => Banner Ad */}
            {/* {verticalBanners?.[0]?.image && ( */}
            <CompanyIntroSection
              className={'mt-3'}
              data={companyData}
              t={t}
              verticalBanner={imageUrl(verticalBanners?.[0]?.image)}
              verticalLink={verticalBanners?.[0]?.link}
              bannerType={verticalBanners[0]?.bannerType}
            />
            {/* )} */}

            <Row className={classes?.dataAndBannerContainer}>
              <Col md={12} lg={10}>
                <div className={classes?.tabsWrapper}>
                  <Tabs
                    scrollOffset={500}
                    tabsData={_tabsData}
                    value={selectedTab}
                    setValue={(e) => {
                      setPage(1);
                      setSelectedTab(e);
                      setPropertyPurpose(null);
                      setFeaturedFilterValue(null);
                      getDataByType(1, {}, e?.value);
                    }}
                    className={classes?.tabsContainer}
                  />
                </div>
              </Col>
              <Col md={12} lg={10}>
                {/* Data count strip */}
                <div className={classes?.dataCountStripContainer}>
                  <div className={classes?.dataStripLeft}>
                    {t('company.filterResults.showing')} 1 - {propertyOrAgent?.data?.length ?? 0} of{' '}
                    {numeral(propertyOrAgent?.totalRecords ?? 0).format('0,0')}{' '}
                    {selectedTab?.value == 'property'
                      ? t('company.filterResults.properties')
                      : selectedTab?.text}
                  </div>
                  {selectedTab?.value !== 'agent' && (
                    <div className={classes?.dataStripRight}>
                      <div>
                        <span>{t('company.filterResults.sortBy')}</span>
                        {selectedTab?.value == 'property' && (
                          <DropDown
                            className={classes.filters}
                            isClearable={true}
                            classNamePrefix={'smDropdown'}
                            placeholder={t('company.filterResults.buyRentSelect')}
                            options={filterOptions}
                            customStyle={{ width: '150px' }}
                            value={propertyPurpose}
                            setValue={(e) => {
                              setPropertyPurpose(e);
                              setPage(1);
                              getDataByType(1, {
                                ...(e?.value
                                  ? {
                                      propertyPurpose: e?.value?.propertyPurpose?.[selectedLanguage]
                                    }
                                  : {}),
                                ...(featuredFilterValue?.value ? featuredFilterValue?.value : {})
                              });
                            }}
                            getOptionLabel={(e) => e?.label?.[selectedLanguage]}
                            getOptionValue={(e) => e?.value?.propertyPurpose?.[selectedLanguage]}
                          />
                        )}
                      </div>
                      <div>
                        <span>{t('company.filterResults.sortBy')}</span>
                        <DropDown
                          className={classes.filters}
                          isClearable={true}
                          classNamePrefix={'smDropdown'}
                          options={_featuredFilterData}
                          value={featuredFilterValue}
                          setValue={(e) => {
                            setFeaturedFilterValue(e);
                            setPage(1);
                            getDataByType(1, {
                              ...e?.value,
                              ...(propertyPurpose?.value
                                ? {
                                    propertyPurpose:
                                      propertyPurpose?.value?.propertyPurpose?.[selectedLanguage]
                                  }
                                : {})
                            });
                          }}
                          getOptionLabel={(e) => e?.label?.[selectedLanguage]}
                          optionValue={'id'}
                          customStyle={{ width: '190px' }}
                          placeholder={t('company.filterResults.featuredPremiumSelect')}
                        />
                      </div>
                    </div>
                  )}
                </div>
                {isGetting || isFetching ? (
                  <Loader className={classes?.itemLoader} />
                ) : (
                  <>
                    {
                      <Row className={classes?.propertiesContainer}>
                        {propertyOrAgent?.data?.length == 0 ? (
                          <NoData text={t('company.notFound')} />
                        ) : (
                          propertyOrAgent?.data?.map((item, index) => {
                            const showBanner =
                              (propertyOrAgent?.data?.length < 5 &&
                                index + 1 === propertyOrAgent?.data?.length) ||
                              (propertyOrAgent?.data?.length >= 5 && index + 1 === 5) ||
                              (propertyOrAgent?.data?.length >= 10 && index + 1 === 10);
                            return (
                              <>
                                <Col md={selectedTab?.value == 'agent' ? 4 : 12} key={`${item?._id}-${index}`}>
                                  {selectedTab?.value === 'project' ? (
                                    <ProjectHorizontalCard
                                      data={item}
                                      index={index}
                                      onEmailClick={() => {
                                        setSelectedItem(item);
                                        setIsModalOpen('email');
                                      }}
                                      refetch={handleRefetch}
                                    />
                                  ) : selectedTab?.value === 'property' ? (
                                    <PropertyHorizontalCard
                                      data={item}
                                      index={index}
                                      onEmailClick={() => {
                                        setSelectedItem(item);
                                        setIsModalOpen('email');
                                      }}
                                      refetch={handleRefetch}
                                    />
                                  ) : selectedTab?.value === 'event' ? (
                                    <EventHorizontalCard
                                      data={item}
                                      index={index}
                                      onEmailClick={() => {
                                        setSelectedItem(item);
                                        setIsModalOpen('email');
                                      }}
                                      refetch={handleRefetch}
                                    />
                                  ) : (
                                    <AgentCard
                                      data={item}
                                      onClick={(agentData) =>
                                        navigate(`/agents/${agentData?.slug}`)
                                      }
                                    />
                                  )}
                                </Col>

                                {showBanner && (
                                  <Col md={12} className="mt-3">
                                    <BannerImageAd
                                      className={classes.horizontalBanner}
                                      link={horizontalBanners[0]?.link}
                                      image={imageUrl(horizontalBanners[0]?.image)}
                                    />
                                  </Col>
                                )}
                              </>
                            );
                          })
                        )}
                      </Row>
                    }

                    {!!propertyOrAgent?.data?.length && (
                      <div className="jCenter">
                        <PaginationComponent
                          totalPages={Math.ceil(propertyOrAgent?.totalRecords / recordsLimit15)}
                          currentPage={page}
                          setCurrentPage={(e) => {
                            setPage(e);
                            getDataByType(e, {
                              ...(propertyPurpose?.value
                                ? {
                                    propertyPurpose:
                                      propertyPurpose?.value?.propertyPurpose?.[selectedLanguage]
                                  }
                                : {}),
                              ...(featuredFilterValue?.value ? featuredFilterValue?.value : {})
                            });
                          }}
                          className={'mb-4'}
                        />
                      </div>
                    )}
                  </>
                )}
              </Col>
              {/* Banner */}
              <Col md={12} lg={2}>
                <div className={classes?.bannerAdContainer}>
                  {verticalBanners[1]?.image && (
                    <BannerImageAd
                      className={classes.verticleBanner}
                      link={verticalBanners[1]?.link}
                      image={imageUrl(verticalBanners[1]?.image)}
                    />
                  )}
                </div>
              </Col>
            </Row>
          </Container>
        )}
        <Footer />
      </div>

      {isModalOpen == 'email' && (
        <EmailAgentModal
          show={isModalOpen == 'email'}
          setShow={setIsModalOpen}
          data={selectedItem}
          type={selectedTab?.value}
          inquiryType={'message'}
        />
      )}
    </>
  );
};

export default CompanyDetailPage;

export const filterOptions = [
  {
    label: { ...propertyPurposeOptions[0] },
    value: { propertyPurpose: propertyPurposeOptions[0] }
  },
  {
    label: { ...propertyPurposeOptions[1] },
    value: { propertyPurpose: propertyPurposeOptions[1] }
  }


];




export const _featuredFilterData = [
  {
    id: 1,
    label: {
      en: 'Featured',
      fa: 'ویژه',
      tr: 'Featured',
      ar: 'مميز',
      ru: 'Премиум',
      de: 'Premium',
      fr: 'Premium'
    },
    value: { isFeatured: true }
  },
  {
    id: 2,
    label: {
      en: 'Premium',
      fa: 'ویژه',
      tr: 'Premium',
      ar: 'مميز',
      ru: 'Премиум',
      de: 'Premium',
      fr: 'Premium'
    },
    value: { isPremium: true }
  },
  {
    id: 3,
    label: {
      en: 'Newest',
      fa: 'جدیدترین',
      tr: 'En Yeniden',
      ar: 'الأحدث',
      ru: 'Самые новые',
      de: 'Neueste',
      fr: 'Le plus récent'
    },
    value: { sortType: 'default' }
  },
  {
    id: 4,
    label: {
      en: 'Lowest Price',
      fa: 'ارزان‌ترین',
      tr: 'En Düşük Fiyat',
      ar: 'أقل سعر',
      ru: 'Самая низкая цена',
      de: 'Niedrigster Preis',
      fr: 'Prix le plus bas'
    },
    value: { sortType: 'lowestPrice' }
  },
  {
    id: 5,
    label: {
      en: 'Highest Price',
      fa: 'گران‌ترین',
      tr: 'En Yüksek Fiyat',
      ar: 'أعلى سعر',
      ru: 'Самая высокая цена',
      de: 'Höchster Preis',
      fr: 'Prix le plus élevé'
    },
    value: { sortType: 'highestPrice' }
  },
  {
    id: 6,
    label: {
      en: 'Largest Area',
      fa: 'بزرگ‌ترین مساحت',
      tr: 'En Büyük Alan',
      ar: 'أكبر مساحة',
      ru: 'Самая большая площадь',
      de: 'Größte Fläche',
      fr: 'La plus grande surface'
    },
    value: { sortType: 'largestArea' }
  }
];

